import { render, staticRenderFns } from "./envSafKpiDetailAppr.vue?vue&type=template&id=eb96f3d8"
import script from "./envSafKpiDetailAppr.vue?vue&type=script&lang=js"
export * from "./envSafKpiDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb96f3d8')) {
      api.createRecord('eb96f3d8', component.options)
    } else {
      api.reload('eb96f3d8', component.options)
    }
    module.hot.accept("./envSafKpiDetailAppr.vue?vue&type=template&id=eb96f3d8", function () {
      api.rerender('eb96f3d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/esk/envSafKpiDetailAppr.vue"
export default component.exports